<template>
  <CardAction
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderLargePrimary :style="style.header">
      Let's get started.
    </HeaderLargePrimary>
    <div :style="style.row">
      <ImagePrimary
        :disableCursor="true"
        :src="sources[0]"
        :style="style.image"
      />
      <div :style="style.text">
        <HeaderMediumPrimary>
          1. Create your skills graph.
        </HeaderMediumPrimary>
        <div :style="style.description">
          Create your skills graph by entering your skills and linking them with relevant skills.
        </div>
      </div>
    </div>
    <div :style="style.gap" />
    <div :style="style.row">
      <ImagePrimary
        :disableCursor="true"
        :src="sources[1]"
        :style="style.image"
      />
      <div :style="style.text">
        <HeaderMediumPrimary>
          2. Complete your profile.
        </HeaderMediumPrimary>
        <div :style="style.description">
          Upload your photo. Add your title, location and links to help coworkers know you better.
        </div>
      </div>
    </div>
    <div :style="style.gap" />
    <div :style="style.row">
      <ImagePrimary
        :disableCursor="true"
        :src="sources[2]"
        :style="style.image"
      />
      <div :style="style.text">
        <HeaderMediumPrimary>
          3. Co-edit skills.
        </HeaderMediumPrimary>
        <div :style="style.description">
          Check your coworkers' skills graph and add any missing skills. It will help team uncover hidden experts in your organization.
        </div>
      </div>
    </div>
  </CardAction>
</template>

<script>
  import CardAction from '@modules/v2/card/card-action'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import ImagePrimary from '@modules/v2/image/image-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { IMAGE_FILES } from '@js/constants'

  export default {
    name: 'Tutorial',
    inheritAttrs: false,
    components: {
      CardAction,
      HeaderLargePrimary,
      HeaderMediumPrimary,
      ImagePrimary,
    },
    data: function () {
      return {
        sources: [
          IMAGE_FILES.TUTORIAL.STEP1,
          IMAGE_FILES.TUTORIAL.STEP2,
          IMAGE_FILES.TUTORIAL.STEP3,
        ].map(elem => require(`@img/${elem}`)),
        style: {
          card: {
            padding: `${Layout.space.md} ${Layout.space.md} 32px ${Layout.space.md}`,
          },
          description: {
            margin: `${Layout.space.sm} 0 0 0`,
          },
          gap: {
            height: '32px',
            width: '100%',
          },
          header: {
            margin: `0 0 ${Layout.space.lg} 0`,
          },
          image: {
            height: '57px',
            margin: `0 ${Layout.space.md} 0 0`,
            minWidth: '80px',
            width: '80px',
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            width: '100%',
          },
          text: {},
        },
      };
    },
  };
</script>
